/**
=========================================================
* Soft UI Dashboard PRO React - v1.0.0
=========================================================

* Product Page: https://www.creative-tim.com/product/soft-ui-dashboard-pro-material-ui
* Copyright 2021 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// Core
import PropTypes from "prop-types";
import { forwardRef } from "react";

// Utils
import clsx from "clsx";

// Components
import Button from "@mui/material/Button";

// Styles
import styles from "components/Atoms/Button/ButtonV1/styles";

const SuiButton = forwardRef(
  (
    { buttonColor, variant, size, circular, iconOnly, children, customClass, href, ...rest },
    ref
  ) => {
    const classes = styles({ buttonColor, variant, size, iconOnly });

    if (href) {
      return (
        <a
          href={href}
          target="_blank"
          rel="noreferrer"
          download
          style={{ display: "inline-block", textDecoration: "none" }}
        >
          <Button
            {...rest}
            ref={ref}
            color="primary"
            variant={variant === "gradient" ? "contained" : variant}
            size={size}
            className={clsx(classes[variant], customClass, {
              [classes.circular]: circular,
              [classes.iconOnly]: iconOnly,
            })}
          >
            {children}
          </Button>
        </a>
      );
    }
    return (
      <Button
        {...rest}
        ref={ref}
        color="primary"
        variant={variant === "gradient" ? "contained" : variant}
        size={size}
        className={clsx(classes[variant], customClass, {
          [classes.circular]: circular,
          [classes.iconOnly]: iconOnly,
        })}
      >
        {children}
      </Button>
    );
  }
);

// Setting default values for the props of SuiButton
SuiButton.defaultProps = {
  size: "medium",
  variant: "contained",
  buttonColor: "white",
  href: "",
  circular: false,
  iconOnly: false,
  customClass: "",
};

// Typechecking props for the SuiButton
SuiButton.propTypes = {
  size: PropTypes.oneOf(["small", "medium", "large"]),
  variant: PropTypes.oneOf(["text", "contained", "outlined", "gradient"]),
  buttonColor: PropTypes.oneOf([
    "white",
    "primary",
    "secondary",
    "info",
    "success",
    "warning",
    "error",
    "light",
    "dark",
  ]),
  href: PropTypes.string,
  circular: PropTypes.bool,
  iconOnly: PropTypes.bool,
  children: PropTypes.node.isRequired,
  customClass: PropTypes.string,
};

export default SuiButton;
